<!--
 * @Author: 夏元元 xiayuanyuan@itcast.cn
 * @Date: 2024-12-30 17:21:30
 * @LastEditors: 夏元元 xiayuanyuan@itcast.cn
 * @LastEditTime: 2025-01-17 14:03:08
 * @FilePath: \subject-topic-new\components\coursePage\design\Box3.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="box3">
    <div class="top">
      <pageTitle
        title="项目定制指导专区"
        titleColor="#313433"
        titColor="#313433"
      /> 
    </div>
    <div class="bottom">
      <img class="title" src="../../../assets/coursePage/design/box3/img01.png"/> 
      <img class="content" src="../../../assets/coursePage/design/box3/img02.png"/>
    </div>
    <a  @click="zixun('咨询客服')" class="btn">咨询客服</a>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
export default {
  components: {
    pageTitle,
    swiper,
    swiperSlide,
  },
  methods: {
    zixun(name) {
      this.$emit('openPop','zixun')
    },
  },
};
</script>

<style lang="less" scoped>
.box3 {
  padding: 0px 0 88px;
  width: 100%;
  background: #E6F6FF;
  .top{
    padding: 80px 0 48px;
    background: url("../../../assets/coursePage/design/box3/bg.png") center center no-repeat;
    background-size: cover;
    box-sizing: border-box;
  }
  .bottom{
    .title{
      height: 80px;
      display: block;
      margin: 0 auto;
    }
    .content{
      width: 734px;
      display: block;
      margin: 24px auto 0 ;
    }
  }
  .btn{
    width: calc(100% - 64px);
    margin: 16px auto 0;
    height: 88px;
    background: linear-gradient( 270deg, #88AEFE 0%, #6698FE 100%);
    border-radius: 48px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 32px;
    color: #FFFFFF;
    line-height: 88px;
    text-align: center;
    font-style: normal;
    display:block;
  }
}
</style>
